import { Text } from '@cmpsr/components';

type ModalIntroWizardStepDescriptionProps = {
  activeStep: number;
};

export default function ModalIntroWizardStepDescription(props: ModalIntroWizardStepDescriptionProps) {
  return renderSwitch(props.activeStep);
}

function renderSwitch(activeStep: number): React.ReactNode {
  switch (activeStep) {
    case 1: {
      return (
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          You may notice that your plan looks different than the guidelines you’ve seen at the doctors office. That’s
          because your Catch Testing Plan is based on the{' '}
          <Text as="span" fontWeight="600" color="text-light" fontStyle="italic">
            latest clinical data
          </Text>{' '}
          on incidence rates by cancer and takes a{' '}
          <Text as="span" fontWeight="600" color="text-light" fontStyle="italic">
            more proactive approach
          </Text>{' '}
          toward screening than conventional guidelines, knowing that early detection can reduce cancer mortality by
          over 90%.
        </Text>
      );
    }
    case 2: {
      return (
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          Unlike conventional screening guidelines that assume everyone has “average” risk, your Catch Annual Testing
          Plan is based on your{' '}
          <Text as="span" fontWeight="600" color="text-light" fontStyle="italic">
            personalized risk
          </Text>{' '}
          for each type of cancer. By optimizing your Testing Plan to your personal risk level, you can be sure you get
          screened for the right cancers at the right time.
        </Text>
      );
    }
    case 3: {
      return (
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          For each test in your plan, we’ll share{' '}
          <Text as="span" fontWeight="600" color="text-light" fontStyle="italic">
            why the test has been recommended
          </Text>{' '}
          for you, as well as all the important information such as its predictive power, cost, and alternative tests if
          available. We will also recommend that you put a{' '}
          <Text as="span" fontWeight="600" color="text-light" fontStyle="italic">
            Target Completion Date
          </Text>{' '}
          for each test in your plan, so you never miss a test.
        </Text>
      );
    }
    case 4: {
      return (
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          Once you complete a test and receive your results, remember to{' '}
          <Text as="span" fontWeight="600" color="text-light" fontStyle="italic">
            mark it complete
          </Text>{' '}
          and share your results. This will enable the Catch risk model to update your risk for the relevant cancer and
          suggest next steps.
        </Text>
      );
    }
    case 5: {
      return (
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          We know that getting screened for cancer can feel nerve-wracking at first, but remember that most cancers have
          a 90%+ survival rate when caught early. That’s why proactive screening is the{' '}
          <Text as="span" fontWeight="600" color="text-light" fontStyle="italic">
            number one way to reduce your risk
          </Text>{' '}
          of dying from cancer. So let’s get started!
        </Text>
      );
    }
  }
}
